module.exports = __webpack_public_path__ + "img/icon-radio.adad96a3.svg";